import { configureStore, createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit'
import authReducer, { setCredentials, logout } from './authSlice'
import { apiSlice } from '../services/api'

// 로그인/로그아웃 시 RTK Query 캐시를 전면 초기화한다.
// - 직전 사용자의 메뉴 권한(getAdminNavMenus 응답)이 새 사용자에게 그대로 노출되는 사고 방지
// - api.ts 의 401 fallback (string action 'auth/logout' 디스패치) 도 isAnyOf 로 함께 잡힌다
const authListenerMiddleware = createListenerMiddleware()
authListenerMiddleware.startListening({
  matcher: isAnyOf(setCredentials, logout),
  effect: (_action, listenerApi) => {
    listenerApi.dispatch(apiSlice.util.resetApiState())
  },
})

export const store = configureStore({
  reducer: {
    auth: authReducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .prepend(authListenerMiddleware.middleware)
      .concat(apiSlice.middleware),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

// 커스텀 훅 타입
import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux'
export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
